"use client";

import Image from "next/image";
import { fontWeights } from "@/utils/fonts";

export interface AwardItem {
  title: string;
  image: string;
  link: string;
}

export interface AwardsRecognitionProps {
  title?: string;
  items?: AwardItem[];
  locationName?: string;
  serviceName?: string;
}

export function AwardsRecognition({ 
  title, 
  items = [], 
  locationName, 
  serviceName 
}: AwardsRecognitionProps) {
  const replaceDynamicPlaceholders = (text: string | undefined) => {
    if (!text) return "";
    return text
      .replace(/{location}/g, locationName || "")
      .replace(/{service}/g, serviceName || "");
  };

  if (items.length === 0) return null;

  const finalTitle = replaceDynamicPlaceholders(title);

  return (
    <section className="py-4 tsm-350:py-6 sm:py-8 md:py-10 lg:py-16 bg-[#F2F4F8]">
      <div className="max-w-[1420px] mx-auto px-4 sm:px-6 lg:px-[100px]">
        <div className="flex flex-col items-center
              mb-4 
              tsm-350:mb-8 
              md:mb-10 
              lg:mb-16 
              xl:mb-20 
            ">
          <h2
            className="text-black leading-tight text-center
              text-[24px] 
              lg:text-[35px]
              2xl:text-[40px] 
              3xl:text-[45px]"
            style={{ fontFamily: "Lato", fontWeight: fontWeights.lato.bold }}
            dangerouslySetInnerHTML={{ __html: finalTitle }}
          />
        </div>

        <div className="grid grid-cols-1 tsm-350:grid-cols-4 
              gap-y-1 
              sm:gap-y-8 
              md:gap-y-0 
              gap-x-2 
              sm:gap-x-6 
              lg:gap-x-12
              ">
          {items.map((award, index) => (
            <a
              key={index}
              href={award.link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-center text-center group"
            >
              <div className="relative w-full flex items-center justify-center
                    h-[100px] 
                    tsm-350:h-[82px] 
                    tsm-400:h-[86px] 
                    sm:h-[100px] 
                    md:h-[130px] 
                    lg:h-[160px] 
                    xl:h-[190px] 
                    mb-2 
                    sm:mb-4 
                    transition-transform
                    duration-300
                    group-hover:scale-110
                  ">
                <Image
                  src={award.image}
                  alt={award.title}
                  fill
                  className="object-contain object-center"
                />
              </div>
              <p
                className="leading-tight max-w-[200px]
                  text-[11px] 
                  tsm-400:text-[13px] 
                  sm:text-[14px] 
                  md:text-[15px] 
                  lg:text-[17px] 
                  text-gray-700
                  group-hover:text-[#002F6D]
                  transition-colors"
                style={{ fontFamily: "Asap", fontWeight: fontWeights.asap.medium }}
              >
                {replaceDynamicPlaceholders(award.title)}
              </p>
            </a>
          ))}

        </div>
      </div>
    </section>
  );
}
